import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { getContentBlockItemsByName } from '../../../Cms/CmsActions';

import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';


const PanelFooterLinks = ({ panel }) => {
    return (
        <Row className="mt-5">
            {getContentBlockItemsByName(panel.blocks, 'footerBlock').map((footerBlock, index) => (
                <Col key={index} xs="12" md="4" className="mb-4 mb-md-0">
                    <div className="footer-block">
                        {footerBlock.title.map((title, index) => <h5 key={index}>{title.text}</h5>)}

                        <ul className="list-unstyled">
                            {footerBlock.links.map((link, index) => <li key={index}><CmsBlockItem item={link} type="link" /></li>)}
                        </ul>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

PanelFooterLinks.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelFooterLinks;

export const PanelFooterLinksModel = {
    type: 'panel',
    name: 'footerLinks',
    blocks: [
        {
            name: 'footerBlock', // name or id; MUST be unique
            type: 'mixed', // || text || link || image || mixed (with children)
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'links',
                    type: 'link',
                },
            ],
            // items: [{text: '<p>azerty 123456</p>'}], // values saved inserted in content model
        },
    ],
};
